import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { PROD, PIT_ROLES } from "../../../common/constants";
import { Box, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { QuickSearchToolbar } from "../../../payment/common/commonFunctions";
import { GET_CONSIGNMENT_LIST, GET_STAKEHOLDER_CATEGORY, DELETE_CONSIGNMENT, UPDATE_CONSIGNMENT } from "../../../common/URLs";
import moment from 'moment';
import { loaderService } from "../../../common/custom-loader/loader-service";

import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import jwt from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import { DialogContent, IconButton, Dialog, DialogActions } from '@mui/material';
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import DeleteIcon from '@mui/icons-material/Delete';
import { CardContent, Card, Tooltip, Typography, Stack, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { UpdateConsignmentPopup } from "../weeklyConsignment/updateConsignmentDetails";
import { useTranslation } from "react-i18next";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";

function InventoryType() {
    const { t } = useTranslation();
    const { state } = useLocation();
    const [tabValue, setTabValue] = React.useState(state?.tabValue ? state?.tabValue : 'RawBamboo');
    const [consignmentListData, setConsignmentListData] = useState();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [stakeholderDetails, setStakeholderDetails] = useState();
    const navigate = useNavigate();
    const [deleteConsignmentNumbers, setDeleteConsignmentNumbers] = useState();
    const [consignmentRowDetails, setConsignmentRowDetails] = useState();
    const [consignmentToDelete, setConsignmentToDelete] = useState();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
    const [logModalOpen1, setLogModalOpen1] = useState(false);
    const [logModalOpen2, setLogModalOpen2] = useState(false);
    const handleLogModalOpen1 = () => setLogModalOpen1(true);
    const handleLogModalClose1 = () => { setLogModalOpen1(false); getConsignmentList(); }
    const handleLogModalOpen2 = () => setLogModalOpen2(true);
    const handleLogModalClose2 = () => { setLogModalOpen2(false); getConsignmentList(); }

    const [logModalOpen3, setLogModalOpen3] = useState(false);
    const handleLogModalOpen3 = () => setLogModalOpen3(true);
    const handleLogModalClose3 = () => setLogModalOpen3(false);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const columns = [
        { field: 'consignmentNumber', headerName: t('pit.consignmentNo'), width: 130 },
        { field: 'consignmentStatus', headerName: t('pit.consignmentStatus'), width: 200 },
        { field: 'deliveryChallanNo', headerName: t('pit.deliveryChallanNo'), width: 150 },
        {
            field: 'challanDate', headerName: t('pit.deliveryChallanDate'), width: 160,
            valueFormatter: params => params?.value != null ? moment(params?.value).format("DD/MM/YYYY") : " "
        },
        { field: 'pickUpLocationURN', headerName: t('pit.sourceUrn'), width: 150 },
        {
            field: 'pickUpLocationAddress', headerName: t('pit.sourceLocation'), width: 250,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                    {params.value}
                </div>
            ),
            valueGetter: (params) => params.value
        },
        { field: 'deliveryLocationURN', headerName: t('pit.destinationUrn'), width: 150 },
        {
            field: 'deliveryLocationAddress', headerName: t('pit.destinationLocation'), width: 250,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                    {params.value}
                </div>
            ),
            valueGetter: (params) => params.value
        },
        { field: 'vehicleRegistration', headerName: t('pit.vehicleNo'), width: 110 },
        { field: 'scheduledConsignmentWeight', headerName: t('pit.quantity') + ' ' + '(MT)', width: 120 },
        { field: 'pickupNetWeight', headerName: 'Pick-up Net Quantity (MT)', width: 140 },
        {
            field: t('reg.actions'), width: 130,
            renderCell: (cellValue) => {
                return (
                    <Tooltip title={t('pit.view')}>
                        <IconButton variant="contained"
                            color="primary"
                            onClick={() => onViewClick(cellValue?.row?.consignmentNumber)}
                        ><ViewIcon /></IconButton>
                    </Tooltip>
                );
            }
        }
    ];

    useEffect(() => {
        getStakeDetails(decoded.extension_URN ? decoded.extension_URN : 'plant');
    }, [tabValue]);

    const getStakeDetails = (urn1) => {
        loaderService.showLoader();
        apiClient
            .post(GET_STAKEHOLDER_CATEGORY,
                {
                    "urn": urn1,
                    "type": ""
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token')
                    }
                }, null
            ).then((response) => {
                setStakeholderDetails(response.data);
                loaderService.hideLoader();
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    useEffect(() => {
        if (stakeholderDetails) {
            getConsignmentList();
        }
    }, [stakeholderDetails]);

    const getConsignmentList = () => {
        loaderService.showLoader();
        apiClient
            .post(GET_CONSIGNMENT_LIST,
                {
                    stakeHolderUrn: stakeholderDetails.urn ? stakeholderDetails.urn : "",
                    stakeHolderType: stakeholderDetails.category ? stakeholderDetails.category : tabValue === "RawBamboo" ? "Transporter" : "",
                    materialType: tabValue

                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token')
                    },
                },
                null
            ).then((response) => {
                setConsignmentListData(response.data.consignmentList);
                // getConsignmentList();
                loaderService.hideLoader()
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const onViewClick = (consignmentNo) => {
        if (tabValue === "RawBamboo") {
            navigate("./LlePickUpDetails", {
                state: { selectedConsNo: consignmentNo, pageName: "inventoryType", tabValue: "RawBamboo" }
            });
        }
        if (tabValue === "ChipBamboo") {
            navigate("./LlePickUpDetails", {
                state: { selectedConsNo: consignmentNo, pageName: "inventoryType", tabValue: "ChipBamboo" }
            });
        }

    }


    const onDeleteConsignment = (consignmentNo) => {
        loaderService.showLoader();
        apiClient
            .post(
                DELETE_CONSIGNMENT,
                {
                    "consignmentNo": consignmentNo,
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setDeleteConsignmentNumbers(response.data);
                getConsignmentList();
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (deleteConsignmentNumbers) {
            if (deleteConsignmentNumbers.isSuccess === true) {
                toast.success(deleteConsignmentNumbers?.message)
                // handleLogModalOpen1();
            } else {
                toast.error(deleteConsignmentNumbers?.message ? deleteConsignmentNumbers?.message : "Error")
                // handleLogModalClose();
            }
        }
    }, [deleteConsignmentNumbers]);

    const onUpdateConsignment = (e, row) => {
        e.preventDefault();
        setConsignmentRowDetails(row);
        handleLogModalOpen3();

    }
    const onCreateClick = () => {
        if (stakeholderDetails?.category === "HIT") {
            navigate('/consignmentCreation')
        }
        else if (stakeholderDetails?.category === "Transporter") {
            navigate('/ChippingConsignmentCreation')
        }

    }

    const onConfirmDelete = () => {
        handleConfirmClose();
        onDelete();
    }

    const onDeleteButtonClick = (consNo) => {
        handleConfirmOpen();
        setConsignmentToDelete(consNo);
    }

    const onDelete = () => {
        onDeleteConsignment(consignmentToDelete);
    }

    return (
        <>
            <Container fluid>
                <Card>
                    <>
                        <TabContext value={tabValue}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleTabChange}>
                                    <Tab label="Raw Bamboo" value="RawBamboo" />
                                    <Tab label="Chip Bamboo" value="ChipBamboo" />
                                </TabList>
                            </Box>
                            <TabPanel value="RawBamboo"> <Box sx={{ height: 450, width: "100%" }}>{consignmentListData &&
                                <DataGrid
                                    rows={consignmentListData}
                                    columns={columns}
                                    getRowId={(row) => row.consignmentNumber}
                                    getRowHeight={() => 'auto'}
                                    pageSize={10}
                                    rowsPerPageOptions={[5]}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                    experimentalFeatures={{ newEditingApi: true }}
                                />}</Box> </TabPanel>
                            <TabPanel value="ChipBamboo"> <Box sx={{ height: 450, width: "100%" }}> {consignmentListData &&
                                <DataGrid
                                    rows={consignmentListData}
                                    columns={columns}
                                    getRowId={(row) => row.consignmentNumber}
                                    getRowHeight={() => 'auto'}
                                    pageSize={10}
                                    rowsPerPageOptions={[5]}
                                    components={{ Toolbar: QuickSearchToolbar }}
                                    experimentalFeatures={{ newEditingApi: true }}
                                />}</Box></TabPanel>
                        </TabContext>
                    </>
                    {/* <Box sx={{ height: 450, width: "100%" }}>
                        {consignmentListData &&
                            <DataGrid
                                rows={consignmentListData}
                                columns={columns}
                                getRowId={(row) => row.consignmentNumber}
                                pageSize={10}
                                rowsPerPageOptions={[5]}
                                components={{ Toolbar: QuickSearchToolbar }}
                                experimentalFeatures={{ newEditingApi: true }}
                            />
                        }
                    </Box> */}
                </Card>
            </Container>

            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmDelete} onClose={handleConfirmClose} action="Delete Consignment" />

            <Dialog maxWidth='xs' fullWidth open={logModalOpen1}>
                <DialogContent>
                    <ConfirmPopover title={deleteConsignmentNumbers?.message ? deleteConsignmentNumbers?.message : "Error"} hideLink={true} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLogModalClose1}>OK</Button>
                </DialogActions>
            </Dialog>
            <Dialog maxWidth='md' fullWidth open={logModalOpen3}>
                <DialogContent>
                    <UpdateConsignmentPopup
                        row={consignmentRowDetails}
                        onClose={handleLogModalClose3}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}
export default InventoryType;